import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sdg',
  templateUrl: './sdg.component.html',
  styleUrls: ['./sdg.component.css']
})
export class SdgComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/sdg/sdg.component.ts